import { create } from "zustand";

export type GarbageHintState = {
  active: boolean;
  x: number;
  y: number;
  angle: number;
  isOnScreen: boolean;
  remainingCount: number;
};

type SceneStore = {
  // Текущая игра
  currentGameId: string;
  setCurrentGameId: (gameId: string) => void;

  totalGarbageCount: number;
  setTotalGarbageCount: (totalCount: number) => void;
  collectedGarbageCount: number;
  setCollectedGarbageCount: (count: number) => void;
  isGamePaused: boolean;
  setIsGamePaused: (paused: boolean) => void;
  garbageHint: GarbageHintState;
  setGarbageHint: (hint: GarbageHintState) => void;
  clearGarbageHint: () => void;

  polutionLevel: number;
  setPolutionLevel: (level: number) => void;
};

const inactiveGarbageHint: GarbageHintState = {
  active: false,
  x: 50,
  y: 50,
  angle: 0,
  isOnScreen: false,
  remainingCount: 0,
};

export const useSceneStore = create<SceneStore>((set) => ({
  currentGameId: '',
  setCurrentGameId: (gameId: string) => set({ currentGameId: gameId }),

  totalGarbageCount: 0,
  setTotalGarbageCount: (totalCount: number) => set({ totalGarbageCount: totalCount }),
  collectedGarbageCount: 0,
  setCollectedGarbageCount: (count: number) => set({ collectedGarbageCount: count }),
  isGamePaused: false,
  setIsGamePaused: (paused: boolean) => set({ isGamePaused: paused }),
  garbageHint: inactiveGarbageHint,
  setGarbageHint: (garbageHint: GarbageHintState) => set({ garbageHint }),
  clearGarbageHint: () => set({ garbageHint: inactiveGarbageHint }),

  polutionLevel: 0,
  setPolutionLevel: (level: number) => set({ polutionLevel: level }),
}));
